/**
 * Transform the deeply-nested json structure from Box into something
 * that is more tailored to our needs, and consistent with the results
 * of locally stored resources.
 *
 * @param {Object} boxResource Object as returned from Box
 * @return {Object} Returns simplified, flattened object
 */

export default function BoxResourceTransformer(boxResource) {

    if (!boxResource.metadata) {
        return boxResource;
    } else {
        return {
            id: boxResource.id,
            title: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.title : '',
            canonical_url: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.canonicalUrl : '',
            description: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.description : '',
            provider_url: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.providerUrl : '',
            provider_name: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.providerName : '',
            provider_display: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.providerDisplay : '',
            favicon_url: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.faviconUrl : '',
            thumbnail_url: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.thumbnailUrl : '',
            published_at: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.publishDate : '',
            posted_at: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.postedAt : '',
            submitted_at: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.submittedAt : '',
            approved_at: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.approvedAt : '',
            approved: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.approved1 : 0,
            posted_by_user_id: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.postedBy : '',
            posted_via: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.postedVia : '',
            slack_url: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.slackUrl : '',
            submitted_by_user_id: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.submittedBy : '',
            insight: (boxResource.metadata) ? boxResource.metadata.enterprise.trendResource.insight : '',
            tags: (boxResource.metadata) ? ((boxResource.tags) ? boxResource.tags.join(',') : '') : '',
            content: (boxResource.content) ? boxResource.content : ''
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/BoxResourceTransformer.js